export enum ActiveFeatureFlags {
  ACCREDIBLE_AVG = 'accredible_avg',
  PATHWAY_ENROLMENT = 'pathway_enrolment',
  PATHWAY_INFORMATION = 'pathway_information',
  PATHWAY_TRACKS = 'pathway_tracks',
  PRE_RENDER_GROUP_IMAGES = 'pre_render_group_images',
  PROFILE_COMPLETION_SIDEBAR = 'profile_completion_sidebar',
  SMARTRESUME_INTEGRATION = 'smartresume_integration',
  SMARTRESUME_INTEGRATION_SHARE_BUTTONS = 'smartresume_integration_share_buttons',
  SPOTLIGHT_BANNERS = 'spotlight_banners',
  V2_EMAIL_ANALYTICS = 'email_analytics_v2',
  EMAIL_EDITOR_GLOBAL_FONTS = 'email_editor_global_fonts',
  V2_EMAIL_EDITOR = 'v2_template_editor',
  ZAPIER_INTEGRATION = 'zapier_integration',
  INTEGRATION_CANVAS_SCHEDULED_AUTOISSUANCE = 'integration_canvas_scheduled_autoissuance',
  YOUTUBE_INSTAGRAM_TIKTOK_SHARE = 'youtube_instagram_tiktok_share',
  CREDENTIAL_ISSUER_ROLE = 'credential_issuer_role',
  ASK_RECOVERY_EMAIL = 'ask_recovery_email',
  SPOTLIGHT_EMAIL_CAMPAIGNS = 'spotlight_email_campaigns',
  COURSE_FINDER_EXPERIMENT = 'course_finder_experiment',
  SPOTLIGHT_DIRECTORY_LICENSE_ID_SEARCH = 'spotlight_directory_license_id_search',
  PHYSICAL_AWARDS_V2 = 'physical_awards_v2',
  PACKAGING_UPDATES = 'packaging',
  SPOTLIGHT_MARKETING_CONTENT = 'spotlight_marketing_content',
  SLACK_SHARING = 'slack_sharing',
  EMAIL_CAMPAIGN_ADOPTION = 'email_campaign_adoption',
  SPIDERABLE_OPTIONS = 'spiderable_options',
  SPOTLIGHT_ANALYTICS_V2 = 'spotlight_analytics_v2',
  CAMPAIGN_SMS_CHANNEL = 'campaign_sms_channel',
  RECOMMENDATIONS_VIA_EMAIL = 'recommendations_via_email',
  SPOTLIGHT_PROFILE_DIRECTORY_OF_DIRECTORIES = 'spotlight_profile_dir_of_dirs',
  VERIFIED_CAREER_RECORDS = 'verified_career_records',
  RECIPIENT_JMI_V2_ITER_2 = 'recipient_jmi_v2_iter_2',
  ISSUER_JMI_V2_ITER_1 = 'issuer_jmi_v2_iter_1',
  ISSUER_JMI_V2_ITER_2 = 'issuer_jmi_v2_iter_2',
  OB3_W3C_DOWNLOAD = 'ob3_w3c_download',
  OB3_W3C_IMPORT = 'ob3_w3c_import',
  OB3_BAKED_IMPORT = 'ob3_baked_import',
  IMPROVED_LTI_ERRORS = 'improved_lti_errors',
  MULTI_DEPARTMENT_ACCESS = 'multi_department_access',
  STRIPE_BILLING_PAGE = 'stripe_billing_page',
  RECIPIENT_CAREERS_INSIGHTS = 'recipient_careers_insights',
  RECIPIENT_LER_ITER_1 = 'recipient_ler_iter_1',
  RECIPIENT_INVITATION_RECOVERY = 'recipient_invitation_recovery',
  MICROSOFT_SMTP_OAUTH = 'microsoft_smtp_oauth',
  BADGE_EDITOR_V2 = 'v2_badge_editor',
}

export type FeatureFlags = {
  [K in ActiveFeatureFlags]: boolean;
};
